"use strict";const e=require("react"),r=e.createContext(void 0);function c(t){const n=e.useContext(r);return t||n||"ltr"}exports.$f631663db3294ace$export$b39126d51d94e6f3=c;
